import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

export default function PasswordMatch({ password, confirm }) {
  if (!confirm) return null;
  const match = password === confirm;
  return (
    <p key={String(match)} className={`flex items-center gap-1.5 text-xs mt-2 animate-fade-up ${match ? 'text-brand-navy-deep font-bold' : 'text-gray-400'}`}>
      {match ? <CheckCircle2 strokeWidth={2.75} className="w-4 h-4 animate-pop" /> : <XCircle className="w-4 h-4" />}
      {match ? 'Passwords match' : "Passwords don't match yet"}
    </p>
  );
}